import module from 'module';

module.factory('customReportHistory', (CacheFactory) =>
  CacheFactory.createCache('customReportHistory', {
    storageMode: 'localStorage',
    storagePrefix: 'nx__nonvolatile__',
  })
);